import { toast } from '@heidi/design-system/toast';
import { GET_TEMPLATES } from '@heidi/templates/contracts';
import {
  invalidateAllTemplatesQuery,
  useQueryTemplates as useQueryTemplatesCore,
} from '@heidi/templates/data';
import type { AxiosError } from 'axios';

// Load-bearing side-effect import: keeps the scribe hub's module evaluation
// order for the template-list cycle. The value is unused.
import '@/pages/api/scribeAPIV2';

export { GET_TEMPLATES, invalidateAllTemplatesQuery };

export function useQueryTemplates() {
  return useQueryTemplatesCore((error: AxiosError) => {
    toast({
      tone: 'destructive',
      title: 'Error',
      description: error.message,
    });
  });
}
